import { AxiosResponse } from "axios";

import {
  IDexcomIntegration,
  IDexcomSyncLog,
} from "../../@types/admin/AdminDexcomIntegration";
import { IPaginatedResponse } from "../../@types/PaginatedResponse";
import { api } from "../api";

const BASE_URL = "/Retool/Dexcom";

/** Dexcom admin page (EN-5232): connected patients and their sync history. Read-only. */
export const dexcomIntegrationService = {
  /** Every connection; paging omitted so search works client-side, as on the Jupyter page. */
  async getIntegrations(): Promise<
    AxiosResponse<IPaginatedResponse<IDexcomIntegration[]>>
  > {
    return api.get<IPaginatedResponse<IDexcomIntegration[]>>(
      `${BASE_URL}/Integrations`
    );
  },

  /** One connection's sync attempts, newest first, paged on the server. */
  async getSyncLogs(
    integrationId: string,
    page: number,
    pageSize: number
  ): Promise<AxiosResponse<IPaginatedResponse<IDexcomSyncLog[]>>> {
    return api.get<IPaginatedResponse<IDexcomSyncLog[]>>(
      `${BASE_URL}/Integrations/${integrationId}/SyncLogs`,
      { params: { page, pageSize } }
    );
  },
};
